import "./RouteFallback.css";

export default function RouteFallback() {
  return (
    <div className="route-fallback" role="status">
      Se încarcă…
    </div>
  );
}
